import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const maintenancePlanActionSchema = surrealRecordSchema.extend({
  date: z.coerce.date(),
});

export type MaintenancePlanAction = z.infer<typeof maintenancePlanActionSchema>;
